import { create } from "zustand";
import { logEvent } from "@um/ui";

interface SupportState {
  isOpen: boolean;
  /** Open the Support & Feedback drawer (mounted once at the app root). */
  openSupport: () => void;
  close: () => void;
}

export const useSupportStore = create<SupportState>((set) => ({
  isOpen: false,

  openSupport: () => {
    logEvent("um_support_request_opened", {
      path: window.location.pathname,
    });
    set({ isOpen: true });
  },

  close: () => set({ isOpen: false }),
}));
